// import {} from '@mantine/core'
// import Link from 'next/link'

import * as Types from '../declarations'

export const getEmailAddress = (version: Types.VERSION) =>
	version === Types.VERSION.TREKKING
		? 'contact@guidedtrekking.com'
		: 'contact@guidedpeaks.com'

const EmailAddress = ({ version }: { version: Types.VERSION }) => {
	const emailAddress =
		version === Types.VERSION.TREKKING ? (
			<>contact@guidedtrekking.com</>
		) : (
			<>contact@guidedpeaks.com</>
		)

	return emailAddress
}

export default EmailAddress
